const badgeBackgroundColors = [
    'red',
    'yellow',
    'green',
    'orange',
    'blue',
    'neonYellow',
    'stone',
    'grayHighContrast',
    'grayLowContrast',
    'black',
    'white',
];
const surfaceOptions = [
    'lightPrimary',
    'lightSecondary',
    'lightBrandNeutral',
    'darkPrimary',
    'darkSecondary',
    'darkBrandHighlight',
    'lightCustom',
    'darkCustom',
];
const validateSurface = (surface, componentName, defaultSurface) => {
    // If surface is not valid, return default
    if (surface && !surfaceOptions.includes(surface)) {
        return defaultSurface !== null && defaultSurface !== void 0 ? defaultSurface : 'lightPrimary';
    }
    switch (surface) {
        case 'lightCustom': {
            return componentName === 'ButtonIcon' ? 'lightSecondary' : 'lightPrimary';
        }
        case 'darkCustom': {
            return componentName === 'ButtonIcon' ? 'darkSecondary' : 'darkPrimary';
        }
        default:
            return surface;
    }
};

export { badgeBackgroundColors, surfaceOptions, validateSurface };
